
import { useEffect, useState } from "react";
import styles from "./Global.module.css";
import { CloseIcon } from "../Icon";
// import { CloseIcon } from "./Icons";

const EnqulryModal = ({ close }) => {
    const [activeTab, setActiveTab] = useState("Retail");
    const [loading, setLoading] = useState(false);
    const [loading2, setLoading2] = useState(false);
    const [formErrors, setFormErrors] = useState({});
    const [userData, setUserData] = useState({
        name: "",
        mobile: "",
        pincode: "",
        city: "",
        district: "",
        state: "",
        country: "India",
        storeName: "",
        source: "dealer",
        status: "New",
    });


    const validateForm = () => {
        const errors = {};
        if (!userData.name.trim()) errors.name = "Name is required";
        if (!userData.mobile) {
            errors.mobile = "Mobile number is required";
        } else if (!/^\d{10}$/.test(userData.mobile)) {
            errors.mobile = "Mobile number must be 10 digits";
        }
        if (!userData.pincode) {
            errors.pincode = "PIN Code is required";
        } else if (!/^\d{6}$/.test(userData.pincode)) {
            errors.pincode = "PIN Code must be 6 digits";
        }
        if (activeTab === "Wholesale" && !userData.storeName.trim()) {
            errors.storeName = "Company name is required";
        }

        setFormErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const handleInputChange = () => {
        if (!validateForm()) return;
        setLoading2(true);
        const myHeaders = new Headers();
        myHeaders.append("wu-platform", process.env.REACT_APP_USER_SECRET);
        myHeaders.append("Content-Type", "application/json");

        const raw = JSON.stringify({
            name: userData.name,
            mobile: userData.mobile,
            pincode: userData.pincode,
            city: userData.city,
            district: userData.district,
            state: userData.state,
            country: userData.country,
            storeName: activeTab === "Wholesale" ? userData.storeName : "",
            type: activeTab.toLowerCase(),
            source: "dealer",
            status: "New",
        });

        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow",
        };

        fetch(process.env.REACT_APP_URL + "leads/createLead", requestOptions)
            .then((response) => response.json())
            .then((result) => {
                alert(result?.msg);
                close(false);
            })
            .catch((error) => console.error(error))
            .finally(() => setLoading2(false));
    };

    const handleLocationsAddress = () => {
        const myHeaders = new Headers();
        setLoading(true);
        myHeaders.append("wu-platform", process.env.REACT_APP_USER_SECRET);
        myHeaders.append("Content-Type", "application/json");

        const raw = JSON.stringify({ keyword: userData.pincode });

        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow",
        };

        fetch(process.env.REACT_APP_URL + "locations/locations", requestOptions)
            .then((response) => response.json())
            .then((result) => {
                if (result.status === "success") {
                    setUserData((prev) => ({
                        ...prev,
                        city: result.SubDistName[0],
                        district: result.districts[0],
                        state: result.states[0],
                    }));
                } else {
                    console.error("Error fetching location data:", result.message);
                }
            })
            .catch((error) => console.error(error))
            .finally(() => setLoading(false));
    };

    useEffect(() => {
        if (userData.pincode.length === 6) {
            handleLocationsAddress();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userData.pincode]);

    return (
        <div className={styles.modalWrapper}>
            <div className={`${styles.section} ${styles.fullHeight}`}>
                <div className={styles.modalContent}>
                    <p className={styles.enquiry_text}>ENQUIRY</p>
                    <span className={styles.close_btn} onClick={() => close(false)}>
                        <CloseIcon />
                    </span>
                    <div className={styles.enquiry_modalHeader}>
                        <div
                            className={styles.activeSlider}
                            style={{
                                transform: activeTab === "Wholesale" ? "translateX(100%)" : "translateX(0%)",
                            }}
                        ></div>

                        {["Retail", "Wholesale"].map((tab) => (
                            <div
                                key={tab}
                                onClick={() => {
                                    setActiveTab(tab);
                                    setFormErrors({});
                                }}
                                className={styles.tab}   
                            >
                                <p>{tab}</p>
                            </div>
                        ))}
                    </div>


                    <div className={styles.enquiry_Input_box_container}>
                        <div className={styles.enquiry_Input_box}>
                            <input
                                type="text"
                                placeholder="Name"
                                value={userData.name}
                                onChange={(e) =>
                                    setUserData({ ...userData, name: e.target.value })
                                }
                            />
                            {formErrors.name && <p className={styles.errorText}>{formErrors.name}</p>}
                        </div>

                        <div className={styles.enquiry_Input_box}>
                            <input
                                type="text"
                                inputMode="numeric"
                                pattern="[0-9]*"
                                maxLength={10}
                                placeholder="Mobile No."
                                value={userData.mobile}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    if (/^\d{0,10}$/.test(value)) {
                                        setUserData({ ...userData, mobile: value });
                                    }
                                }}
                            />

                            {formErrors.mobile && <p className={styles.errorText}>{formErrors.mobile}</p>}
                        </div>

                        {activeTab === "Wholesale" && (
                            <div className={styles.enquiry_Input_box}>
                                <input
                                    type="text"
                                    placeholder="Company Name"
                                    value={userData.storeName}
                                    onChange={(e) =>
                                        setUserData({ ...userData, storeName: e.target.value })
                                    }
                                />
                                {formErrors.storeName && (
                                    <p className={styles.errorText}>{formErrors.storeName}</p>
                                )}
                            </div>
                        )}

                        <div className={styles.enquiry_Input_box}>
                            <input
                                type="text"
                                inputMode="numeric"
                                pattern="[0-9]*"
                                maxLength={6}
                                placeholder="PIN Code"
                                value={userData.pincode}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    if (/^\d{0,6}$/.test(value)) {
                                        setUserData({ ...userData, pincode: value });
                                    }
                                }}
                            />

                            {formErrors.pincode && (
                                <p className={styles.errorText}>{formErrors.pincode}</p>
                            )}
                            {userData.pincode.length === 6 && loading ? (
                                <p className={styles.enquiry_Input_box_p}>Loading...</p>
                            ) : userData.pincode.length === 6 ? (
                                <p className={styles.enquiry_Input_box_p}>{`${userData.city} / ${userData.district} / ${userData.state}`}</p>
                            ) : null}

                        </div>
                    </div>

                    <div className={styles.enquiry_Input_box_container} style={{ marginTop: "20px" }}>
                        <button
                            className={`${styles.enquiry_btn} ${loading2 || loading ? styles.loading : ""}`}
                            onClick={handleInputChange}
                            disabled={loading || loading2}
                        >
                            Submit
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EnqulryModal;


